import {
  type MutationState,
  useMutationState,
  type Mutation,
  type MutationKey
} from "@tanstack/react-query";

// Get mutation type from a mutation hook
export type MutationType<
  T extends (...args: unknown[]) => {
    data: unknown;
    error: unknown;
    variables: unknown;
  }
> = Mutation<
  ReturnType<T>["data"],
  ReturnType<T>["error"],
  ReturnType<T>["variables"]
>;

export function useLatestMutation<TData>({ key }: { key: MutationKey }) {
  const mutations = useMutationState<
    MutationState<TData, Error, unknown> | undefined
  >({
    filters: {
      mutationKey: key
    },
    select: (mutation) => mutation.state as MutationState<TData, Error, unknown>
  });

  return mutations[mutations.length - 1];
}
